import React from 'react';

const ListItem = ({ children }) => (
  <li className="leading-loose pl-6 relative">{children}</li>
);

export default ListItem;
